module.exports = __webpack_public_path__ + "static/media/1euro.b82372c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/coupures/1euro.png
// module id = 926
// module chunks = 0